<div class="marquee-header-title" *ngIf="backgroundContainerConfig.showTitle">
    <div class="title-icon" *ngIf="isRequiredTitleIcon()">
        <ms-competition-logo
            class="icon"
            *ngIf="checkTitleIcon; else staticTemplate"
            [sportId]="titleIcon.sportId"
            [leagueId]="titleIcon.id"
            [fallbackIcon]="titleIcon.icon" />
        <ng-template #staticTemplate>
            <span class="icon" [ngClass]="titleIcon.icon"></span>
        </ng-template>
    </div>
    <div class="title-text">{{ title }}</div>
</div>
<div class="marquee-header-link">
    <ms-item *ngIf="globalLinkConfig.visible && globalLink && globalLinkText" [href]="globalLink" [tracking]="undefined" (click)="linkClick()">
        <span item-title [innerHtml]="globalLinkText | msTrust: 'html'"></span>
    </ms-item>
</div>
